import $x from './$x'
import kygMsg from './kygMsg.js'

export default {
    jumpApp(urlPath, routeQuery) {
        var route = {
            path: location.hash.slice(1),
            query: routeQuery,
        }
        //保存当前页面信息用于返回
        $x.storage.setObj('jumpOutPars', route)
        if (!urlPath.match(/^http/)) urlPath = $x.serverMap.domain + urlPath
        location.href = urlPath;
    },
    jumpMenu(menu, routeQuery) {
        if (menu.winparas === 'notSet') {
            var { sid, xpath } = menu
            $x.post('/home/getAppWinParas', { sid, xpath }).then(winparas => {
                menu.winparas = !!winparas
                goWin()
            })
        } else {
            goWin()
        }

        function goWin() {
            let url = '';
            if (menu.winparas === false) {
                url = 'PortalMobile/Window.aspx?path=' + menu.xpath + '&sid=' + menu.sid;
            } else {
                url = 'PortalMobile/WindowPars.aspx?path=' + menu.xpath + '&title=' + encodeURI(menu.title || '') + '&sid=' + menu.sid;
            }
            $x.jumpApp(url, routeQuery);
        }
    },

    //用法同C#
    strFormat(format) {
        if (format) {
            var args = [].slice.call(arguments, 1);
            for (var i = 0; i < args.length; i++) {
                format = format.replace(new RegExp('\\{' + i + '\\}', 'g'), args[i]);
            }
        }
        return format;
    },
    t: kygMsg
}
